import { useIsMenuActive } from "@/components/helpers";
import { Menu } from "@/models";
import classnames from "classnames";
import Link from "next/link";
import { FC, PropsWithChildren } from "react";

export const AsideMenuItem: FC<PropsWithChildren<{ menu: Menu }>> = ({ menu, children }) => {
  const isMenuActive = useIsMenuActive();

  return (
    <div className="menu-item">
      <Link
        href={`/${menu.link ?? ""}`}
        data-kt-drawer-dismiss="true"
        className={classnames(
          "menu-link without-sub",
          { active: isMenuActive(menu) }
        )}>

        <span className="menu-icon">
          <span className={classnames("mdi", menu.icone?.trim() || "bullet bullet-dot")} />
        </span>
        <span className="menu-title">{menu.nome}</span>

      </Link>
      {children}
    </div >
  );
};
